/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Decklist_Required_DescInputs */



/**
* | output |
* | --- |
* | "warning badge until deck uploaded" |
*
* @param {Og_Cfg_Decklist_Required_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_decklist_required_desc = /** @type {((inputs?: Og_Cfg_Decklist_Required_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Decklist_Required_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("badge d'avertissement jusqu'à la soumission du deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("insignia de advertencia hasta que se cargue el mazo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("emblema de aviso até o deck ser enviado")
	if (locale === "it") return /** @type {LocalizedString} */ ("badge di avvertimento finché il mazzo non è caricato")
	return /** @type {LocalizedString} */ ("warning badge until deck uploaded")
});